import { cx } from 'class-variance-authority';

export const popoverVariants = cx(
  'fixed z-50 overflow-hidden rounded-lg outline-none',
  'border border-neutral-200 bg-white shadow-lg ring-0',
  'origin-[var(--ngp-popover-transform-origin)]',
  'min-w-[var(--ngp-popover-trigger-width)]',
  'data-[enter]:animate-scale-in data-[instant]:data-[enter]:animate-none',
  'data-[exit]:animate-scale-out data-[instant]:data-[exit]:animate-none',
);
